// eslint-disable-next-line no-use-before-define
var _kwazii = _kwazii || { 'datasource': '' };
window._kwazii = _kwazii;

(function () {
  try {
    function generateGUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          //eslint-disable-next-line
          v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    var _kwaziiSessionId = generateGUID();

    /**
     * Adds the marked script dynamically to the HTML document.
     */
    function addMarkedScript() {
      // Find the <head> tag
      const headTag = document.querySelector("head");

      // Create a <script> element
      const scriptTag = document.createElement("script");

      // Set the source of the script to the marked library
      scriptTag.src = "https://cdn.jsdelivr.net/npm/marked/marked.min.js";

      // Append the script tag to the <head> tag
      headTag.appendChild(scriptTag);
    }

    /**
     * Adds Bootstrap CSS and JS to the HTML document if they are not already included.
     */
    function addBootstrap() {
      // Get all the <link> and <script> elements in the document
      const links = Array.from(document.querySelectorAll("link"));
      const scripts = Array.from(document.querySelectorAll("script"));

      // Check if Bootstrap CSS is already included
      const cssExists = links.some(link =>
        link.href.includes("bootstrap.min.css")
      );
      if (!cssExists) {
        // Create a <link> element for Bootstrap CSS
        const cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.href =
          "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css";

        // Append the CSS link to the <head> tag
        document.head.appendChild(cssLink);
      }

      // Check if Font Awesome CSS is already included
      const faCssExists = links.some(link =>
        link.href.includes("font-awesome.min.css")
      );
      if (!faCssExists) {
        // Create a <link> element for Font Awesome CSS
        const cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.href =
          "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";

        // Append the CSS link to the <head> tag
        document.head.appendChild(cssLink);
      }

      // Check if Bootstrap JS is already included
      const jsExists = scripts.some(script =>
        script.src.includes("bootstrap.bundle.min.js")
      );
      if (!jsExists) {
        // Create a <script> element for Bootstrap JS
        const jsScript = document.createElement("script");
        jsScript.src =
          "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js";

        // Append the JS script to the <body> tag
        document.body.appendChild(jsScript);
      }
    }

    /**
     * Creates a new stylesheet and inserts CSS rules into it.
     */
    function createStylesheet() {
      // Create a <style> element
      const styleEl = document.createElement("style");

      // Append the <style> element to the <head> tag
      document.head.appendChild(styleEl);

      // Get the stylesheet object
      const styleSheet = styleEl.sheet;

      // Define CSS rules
      const cssRules = [
        `#kwazii-new {
        font-size: 0.7rem;
        background: #0d6efdc4;
        padding: 0 5px;
        border-radius: 5px;
        transform: translateY(-8px) translateX(2px) rotate(-5deg);
        display: inline-block;
        color: white;
        }`,
        `.active #kwazii-new {
        background: #495057;
        }`,
        `#kwazii-tabs-parent .nav {
        list-style: none;
        margin-bottom: 0;
      }`,
        `#kwazii-tabs-parent .nav-item {
        list-style: none;
        margin: 0;
      }`,
        `#kwaziiTabContent {
        position: relative;
        font-size: 15px;
      }`,
        `#kwaziiTabContent.tab-content > .tab-pane {
        visibility: hidden;
        position: relative;
        float: left;
        top: 0;
        left: 0;
        width: 100%;
      }`,
        `#kwaziiTabContent.tab-content > .active {
        visibility: visible;
      }`,
        `#kwazii-search {
        -webkit-text-size-adjust: 100%;
        color: #555555;
        margin: 0;
        padding: 0;
        border: 0;
        font: inherit;
        vertical-align: baseline;
        margin-top: 30px;
        margin-bottom: 50px;
      }`,
        `#kwazii-search {
        padding-left: 0px;
        padding-right: 0px;
      }`,
        `@media (min-width: 768px) {
        #kwazii-search {
          padding-left: 20px;
          padding-right: 20px;
        }
      }`,
        `@media (min-width: 1200px) {
        #kwazii-search {
          padding-left: 50px;
          padding-right: 50px;
        }
      }`,
        ...(window._kwazii['css_rules'] || [])
      ];

      // Insert each CSS rule into the stylesheet
      cssRules.forEach(rule => {
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
      });
    }

    /**
     * Adds a navigation pill and moves Reamaze content within the HTML document.
     */
    function addNavPill() {
      // Find the Reamaze placeholder element
      const reamazePlaceholderElement = document.querySelector(
        window._kwazii['search_target_selector'] || 'div[data-reamaze-embed="kb"]'
      );

      // Find the parent node of the Reamaze placeholder element
      const parentNodeReamazePlaceholderElement = reamazePlaceholderElement.parentNode;

      if (reamazePlaceholderElement) {
        // Create a parent <div> element for the navigation pill
        const tabParent = document.createElement("div");
        tabParent.id = "kwazii-tabs-parent";
        tabParent.style.display = "flex";
        tabParent.style.flexDirection = "column";
        tabParent.innerHTML = `
        <!-- Navigation pill -->
        <ul class="nav justify-content-center nav-tabs" id="kwazii-tabs" role="tablist">
          <li class="nav-item">
            <button class="nav-link active" id="reamaze-tab" data-bs-toggle="tab" data-bs-target="#tab-pane-reamaze-embed-kb" type="button">Search</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" id="kwazii-tab" data-bs-toggle="tab" data-bs-target="#tab-pane-kwazii-embed-kb" type="button">
              <i class="fa-solid fa-bolt" style='margin-right: 5px'></i>Ask AI
              <span id='kwazii-new'>new<span>
            </button>
          </li>
        </ul>

        <!-- Tab content -->
        <div class="tab-content" id="kwaziiTabContent">
          <div class="tab-pane fade show active" id="tab-pane-reamaze-embed-kb" role="tabpanel" aria-labelledby="tab-pane-reamaze-embed-kb"></div>
          <div class="tab-pane fade" id="tab-pane-kwazii-embed-kb" role="tabpanel" aria-labelledby="tab-pane-kwazii-embed-kb">
            <div id="kwazii-search">
              <iframe id="kwazii-search-iframe" src="${getKwaziiIframeUrl()}" style='overflow:hidden; width:100%; min-height: ${window._kwazii['iframe_height'] || '200px'};' frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      `;

        // Append the parent <div> element to the parent node of the Reamaze placeholder element
        parentNodeReamazePlaceholderElement.append(tabParent);

        // Move the Reamaze content to the corresponding tab pane
        const tabPaneReamazeEmbedKb = document.querySelector(
          "#tab-pane-reamaze-embed-kb"
        );
        tabPaneReamazeEmbedKb.appendChild(reamazePlaceholderElement);


        const reamazeTab = document.querySelector("#reamaze-tab");
        reamazeTab.addEventListener("click", function (event) {
          const iframe = document.querySelector('iframe[title="FAQ"]');
          if (iframe) {
            iframe.src = iframe.src + "";
          } else {
            console.log("Could not find the iframe with title 'FAQ'.");
          }
        });
      }
    }

    function getKwaziiIframeUrl() {
      let url = "https://platform.kwazii.app/ui_applications/kb_search";
      switch (window._kwazii['service_env']) {
        case 'local': url = "http://localhost:3000/ui_applications/kb_search"; break
        case 'staging': url = "https://stag-platform.kwazii.app/ui_applications/kb_search"; break
        default: break;
      }

      url = `${url}/?applicationId=${window._kwazii['applicationId']}&apiKey=${window._kwazii['apiKey']}&enableAutoScroll=${!!window._kwazii['enableAutoScroll']}&sessionId=${_kwaziiSessionId}`

      return url;
    }

    function getKwaziiAPIUrl() {
      let url = "https://api.kwazii.app/v1";
      switch (window._kwazii['service_env']) {
        case 'local': url = "http://localhost/v1"; break
        case 'staging': url = "https://staging-api.kwazii.app/v1"; break
        default: break;
      }

      return url;
    }

    // let isObserveBodyHeightChanges = false;

    // Add an event listener to listen for the 'message' event
    window.addEventListener('message', receiveMessage, false);

    function scrollIfElementBottomIsOutside(el) {
      var rect = el.getBoundingClientRect();

      var isInViewPort = (
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );

      if (!isInViewPort) {
        el.scrollIntoView(false); // scrolls to the bottom of the element
      }
    }

    let previousHeight = 0;
    // Function to handle the received message
    function receiveMessage(event) {
      // // Make sure the origin of the message is trusted to avoid security issues
      // // In production, replace 'example.com' with the actual origin of the sender
      // if (event.origin !== 'https://www.example.com') {
      //   return;
      // }

      // Check if the message is the one we're expecting (kwazii:resize)
      const data = event.data;
      if (data.message === 'kwazii:resize') {
        const iframeElement = document.querySelector("#kwazii-search-iframe");
        let newHeight = Number(data.height);
        if (previousHeight < newHeight || newHeight < 200) {
          // console.log(`${previousHeight}   ${newHeight}`);
          // UPDATE 100 to appropiate value if ANSWER BOX HEIGHT IS CHANGED
          iframeElement.height = newHeight + 25;
          scrollIfElementBottomIsOutside(iframeElement);
          previousHeight = newHeight;
        }
      }
    }

    function attachAITabSelectedAnalytics() {
      document.querySelector("#kwazii-tab").addEventListener("click", (event) => {
        const analyticsData = {
          timestamp: new Date(),
          applicationId: window._kwazii['applicationId'],
          pageUrl: window.location.href,
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          browser: getBrowserInfo(),
          os: getOSInfo(),
          device: getDeviceInfo(),
          screenResolution: `${window.screen.width}x${window.screen.height}`,
          geoLocation: {}, // You can capture actual geolocation data here
          sessionId: _kwaziiSessionId,
          eventType: 'click',
          customData: {
            elementId: event.target.id,
            buttonText: 'AI tab'
          }
        };

        // Simulate sending the analytics data to the server
        sendAnalyticsData(analyticsData);
      });
    };

    function trackAnalytics() {
      const analyticsData = {
        timestamp: new Date(),
        applicationId: window._kwazii['applicationId'],
        pageUrl: window.location.href,
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        browser: getBrowserInfo(),
        os: getOSInfo(),
        device: getDeviceInfo(),
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        geoLocation: {}, // You can capture actual geolocation data here
        eventType: 'pageView',
        sessionId: _kwaziiSessionId,
        customData: {}
      };

      // Simulate sending the analytics data to the server
      sendAnalyticsData(analyticsData);
    };

    // Function to send analytics data to the specified API endpoint
    async function sendAnalyticsData(data) {
      const apiUrl = `${getKwaziiAPIUrl()}/tracking`;

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-KWAZII-API-KEY': window._kwazii['apiKey']
          },
          body: JSON.stringify(data)
        });

        if (response.ok) {
          console.log('Analytics data sent successfully');
        } else {
          console.error('Failed to send analytics data:', response.statusText);
        }
      } catch (error) {
        console.error('An error occurred while sending analytics data:', error);
      }
    }

    // Function to get browser information
    function getBrowserInfo() {
      const userAgent = navigator.userAgent;
      const browserMatch = userAgent.match(/(chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i);
      return browserMatch && browserMatch[0];
    }

    // Function to get OS information
    function getOSInfo() {
      const userAgent = navigator.userAgent;
      const osMatch = userAgent.match(/(win|mac|linux)/i);
      return osMatch && osMatch[0];
    }

    // Function to get device information
    function getDeviceInfo() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      return isMobile ? 'Mobile' : 'Desktop';
    }

    // Function to send analytics data to the specified API endpoint
    async function isApplicationEnabled() {
      const apiUrl = `${getKwaziiAPIUrl()}/applications/${window._kwazii['applicationId']}`;

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-KWAZII-API-KEY': window._kwazii['apiKey']
          }
        });

        if (response.ok) {
          const application = await response.json();
          // eslint-disable-next-line
          // debugger;

          return !application?.data?.disabled;
        } else {
          console.log('Failed to fetch application', response.statusText);
          return false;
        }
      } catch (error) {
        console.log('Failed to fetch application', error);
        return false;
      }
    }

    const targetElement = document.querySelector(window._kwazii['search_target_selector'] || 'div[data-reamaze-embed="kb"]');
    if (targetElement) {
      setTimeout(async () => {
        const appEnabled = await isApplicationEnabled();
        if (appEnabled) {
          // Call the necessary functions
          addMarkedScript();
          createStylesheet();
          addNavPill();
          addBootstrap();
          trackAnalytics();
          attachAITabSelectedAnalytics();
        }
      });
    } else {
      // Define the function to run when the element appears
      async function handleElementAppearance(mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const targetElement = document.querySelector(window._kwazii['search_target_selector'] || 'div[data-reamaze-embed="kb"]');
            // Check if the added node is the target element
            if (mutation.addedNodes[0] === targetElement) {
              // Your code to run when the element appears
              console.log("The element - reamaze-embed - has appeared on the page!");

              // Disconnect the observer since we don't need it anymore
              observer.disconnect();

              const appEnabled = await isApplicationEnabled();
              if (appEnabled) {
                // Call the necessary functions
                addMarkedScript();
                createStylesheet();
                addNavPill();
                addBootstrap();
                trackAnalytics();
                attachAITabSelectedAnalytics();
              }
            }
          }
        }
      }

      // Create a new MutationObserver
      const observer = new MutationObserver(handleElementAppearance);

      // Start observing changes in the parent element of the target
      observer.observe(document.body, { childList: true, subtree: true });
    }

  } catch (error) {
    console.log("Failed to enable kwazii", error);
  }
})();
